const FormResources = {

    note_form_data: {
        parent_id:      '',
        title:          '',
        content:        '',
        creation_date:  '',
    },

    note_form_format: [
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Content:',
            model_name: 'content',
            ref:        'content_input',
            ref_alt:    'content_input_alt',
            required:   true,
        },
    ],

}

export default FormResources